import { formatRevisionNumber } from './formatRevisionNumber';
import { TRAINING_EMPTY_VALUE } from './trainingEmptyValue';

export function formatTrainingMatrixRevisionShortLabel(
  revision: { revision: number } | null | undefined
): string {
  if (!revision) return TRAINING_EMPTY_VALUE;

  return `Rev.${formatRevisionNumber(revision.revision)}`;
}
